import { useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import { useTranslation } from "react-i18next"
import useStorages from "hooks/useStorages"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import RightSidebar from "components/sidebar/right/RightSidebar"
import PageTitle from "features/navigation/pageTitle"
import { paramGuardStorage } from "@/utils/paramGuard"
import HistoryList from "@/components/history/HistoryList"

const HistoryPage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const { targetStorageDocId: storageId } = useTargetStorage()

    const {
        storage,
        storageStatus
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleHistory')} />
            <Section padX={false}>
                <HistoryList storageId={safeStorageId} displayDocType={true} allDocTypes />
            </Section>
            <RightSidebar />
        </>
    )
}

export default HistoryPage
